import dayjs from 'dayjs';
import { formatNumber } from './format';

/**
 * Meta de agendamentos por mês (Preferências > Metas e Limites). Vem do
 * CompanyConfig como número ou texto; sem meta (vazio ou zero) devolve null.
 */
export function monthlyGoal(companyConfig) {
  const goal = Number(companyConfig && companyConfig.TargetOccupation);
  return Number.isFinite(goal) && goal > 0 ? goal : null;
}

/** Quantos meses o período toca (1 a 13 de outubro = 1; 1 de agosto a 13 de outubro = 3). */
export function monthsInPeriod(period) {
  if (!period || !period.start || !period.end) return 1;
  return Math.max(1, dayjs(period.end).startOf('month').diff(dayjs(period.start).startOf('month'), 'month') + 1);
}

/**
 * Dica do card "Previsto": quanto falta para a meta do período (meta mensal
 * vezes os meses do período) ou que ela já foi batida.
 */
export function goalHint(value, goal, period) {
  if (!goal) return undefined;
  const months = monthsInPeriod(period);
  const target = goal * months;
  const perMonth = months > 1 ? ` (${formatNumber(goal)} por mês)` : '';
  const current = Number(value) || 0;
  if (current >= target) return `meta de ${formatNumber(target)} batida${perMonth}`;
  return `faltam ${formatNumber(target - current)} para a meta de ${formatNumber(target)}${perMonth}`;
}
